import { formatDateForMySQL } from "components/formatDate";
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";
import { SendNotification } from "components/SendNotification";

export const SaveClientServiceRequest = async (serviceRequest,toast) => {
    try {
        var propertySize = serviceRequest.propertySize ? `How big your property is? : ${serviceRequest.propertySize}` : "";
        var propertyCount = serviceRequest.numberOfProperties ? `How many properties do you have? : ${serviceRequest.numberOfProperties}` : "";
        var bestTimeToCall = serviceRequest.bestTimeToCall ? `When can we call you? : ${serviceRequest.bestTimeToCall}` : "";
        var specialInstructions = serviceRequest.specialInstructions ? `Special instructions? : ${serviceRequest.specialInstructions}` : "";
        var servicesRequested = serviceRequest.servicesRequested ? `Services requested? : ${serviceRequest.servicesRequested}` : "";
             var reqDescription = 
      `${serviceRequest.reqDescription?.trim() || ''}${servicesRequested ? '\n' + servicesRequested : ''}${propertySize ? '\n' + propertySize : ''}${propertyCount ? '\n' + propertyCount : ''}${bestTimeToCall ? '\n' + bestTimeToCall : ''}${specialInstructions ? '\n' + specialInstructions : ''}`.trim();
        let Payload  =
        {
                "propertyType": serviceRequest.propertyType,
                "firstname": serviceRequest.firstname,
                "lastname": serviceRequest.lastname,
                "companyName": serviceRequest.companyName,
                "companyPhone": serviceRequest.companyPhone,
                "companyEmail": serviceRequest.companyEmail,
                "requestTitle": serviceRequest.requestTitle,
                "jobsiteAddress": serviceRequest.jobsiteAddress,
                "phone": serviceRequest.phone,
                "email": serviceRequest.email,
                "additionalContact": serviceRequest.additionalContact,
                "servicesRequested": serviceRequest.servicesRequested,
                "reqDescription": reqDescription ? reqDescription.trim() : '',
                "token": serviceRequest.token            
        };

          //  console.log(Payload);
      const response = await fetch(`${dev_baseUrl}/ServiceRequest/saveClientServiceRequest`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
  
      
      const data = await response.json();                      
      // console.log(data)
      if (!response.ok && data.isError) {
        toast.error(data.message || 'An error occurred. Please try again later.');
      } else {      
        //SendNotification(navigate);
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
};